import React, { useEffect, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import dayjs from 'dayjs';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';

import {
    Text,
    PatientSessionCard,
    NoInformation,
    Progress,
    Header,
    PatientDetailTab,
} from '../../components';

import { patientPageWidth } from '../../constant';

import { GET_NEXT_APPOINTMENT } from '../../services/patient';

import { alertError } from '../../redux/stateActions';

import socket from '../../socket';

const Appointment = ({ history }) => {
    const mobileS = useMediaQuery('(max-width:374.95px)');

    const dispatch = useDispatch();

    const user = useSelector((state) => state.user);

    const [selectedTab, setSelectedTab] = useState(0);

    const tabsChangeHandler = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const [date, setDate] = useState(null);

    useEffect(() => {
        setDate(dayjs().format('YYYY-MM-DD'));
    }, []);

    /*--------------- Get Next Appointment ---------------*/
    const [oneOnOneSessions, setOneOnOneSessions] = useState([]);
    const [groupSessions, setGroupSessions] = useState([]);
    const [openSessions, setOpenSessions] = useState([]);

    const {
        data: getNextAppointmentData,
        error: getNextAppointmentError,
        loading: getNextAppointmentLoading,
        refetch: getNextAppointmentRefetch,
    } = useQuery(GET_NEXT_APPOINTMENT, {
        variables: {
            limit: 0,
            id: user.patient.id,
            date: date,
        },
        skip: _.isEmpty(user) || !date,
        pollInterval: 30000,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (getNextAppointmentError) {
            dispatch(alertError(`Cannot get Next Appointment`));
        }
        if (getNextAppointmentData && getNextAppointmentData?.sessions) {
            const newOneOnOneSessions = getNextAppointmentData.sessions.filter(
                (session) => session?.meet?.type === 'one'
            );
            setOneOnOneSessions(newOneOnOneSessions);

            const newGroupSessions = getNextAppointmentData.sessions.filter(
                (session) => session?.meet?.type === 'group'
            );
            setGroupSessions(newGroupSessions);

            const newOpenSessions = getNextAppointmentData.sessions.filter(
                (session) => session?.meet?.type === 'open'
            );
            setOpenSessions(newOpenSessions);
        }
    }, [getNextAppointmentError, getNextAppointmentData]);

    const onSessionDetail = (session) => {
        if (!_.isEmpty(session)) {
            history.push(`/appointment/${session.meet.type}/${session.id}`);
        }
    };

    const handleGoBack = () => {
        history.goBack();
    };
    const handleSearch = () => {
        console.log('handleSearch');
    };

    const meetType = (tab) => {
        switch (tab) {
            case 0:
                return oneOnOneSessions;
            case 1:
                return groupSessions;
            default:
                return openSessions;
        }
    };

    useEffect(() => {
        socket.on('newSession', () => {
            getNextAppointmentRefetch();
        });
        socket.on('sessionUpdated', () => {
            getNextAppointmentRefetch();
        });
    }, []);

    return (
        <div
            style={{
                margin: '0 15px',
                width: '100%',
                maxWidth: patientPageWidth,
                display: 'flex',
                flexDirection: 'column',
                padding: mobileS ? '0 5px' : '0 15px',
                height: '100vh',
            }}
        >
            <Header
                showGoBack1
                onClickGoBack={handleGoBack}
                onSearch={handleSearch}
                childrenContainerStyle={{ textAlign: 'center' }}
            >
                <Text $bold>Appointments</Text>
            </Header>

            <StyledTabs
                value={selectedTab}
                onChange={tabsChangeHandler}
                TabIndicatorProps={{ style: { height: '4px', backgroundColor: 'black' } }}
            >
                <PatientDetailTab
                    label={<span style={labelStyle}>1 on 1</span>}
                    $active={selectedTab === 0}
                />
                <PatientDetailTab
                    style={{ padding: '0 15px' }}
                    label={<span style={labelStyle}>Group</span>}
                    $active={selectedTab === 1}
                />
                <PatientDetailTab
                    style={{ padding: '0 15px' }}
                    label={<span style={labelStyle}>Open</span>}
                    $active={selectedTab === 2}
                />
            </StyledTabs>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '15px',
                    position: 'relative',
                    overflowY: 'auto',
                    paddingBottom: '75px',
                }}
            >
                {getNextAppointmentLoading && <Progress />}
                {!_.isEmpty(meetType(selectedTab)) ? (
                    meetType(selectedTab).map((session) => (
                        <PatientSessionCard
                            data={session}
                            key={session.id}
                            onCheckIn={() => onSessionDetail(session)}
                        />
                    ))
                ) : (
                    <NoInformation />
                )}
            </div>
        </div>
    );
};

Appointment.propTypes = {
    history: PropTypes.object,
};

export default Appointment;

const StyledTabs = withStyles({
    root: {
        marginBottom: '24px',
    },
    flexContainer: {
        justifyContent: 'center',
    },
})(Tabs);

const labelStyle = {
    fontWeight: 'bold',
    margin: '0 15px',
};
